// @ts-nocheck
import { Plus, Trash2, Copy } from 'lucide-react'
import TimeSlotEditor from './TimeSlotEditor'

export default function DayScheduleRow({ dayKey, dayLabel, dayData, onChange, onCopyToAll }) {
  // dayDataがない場合はデフォルト値を使用
  const defaultDayData = { isOpen: false, hours: [] }
  const currentDayData = dayData || defaultDayData

  const handleToggleOpen = () => {
    if (!currentDayData.isOpen) {
      // 休業日から営業日に変更する場合、デフォルト時間を設定
      onChange({
        isOpen: true,
        hours: [{ start: '09:00', end: '18:00' }],
      })
    } else {
      // 営業日から休業日に変更
      onChange({
        isOpen: false,
        hours: [],
      })
    }
  }

  const handleAddTimeSlot = () => {
    onChange({
      ...currentDayData,
      hours: [...currentDayData.hours, { start: '09:00', end: '18:00' }],
    })
  }

  const handleRemoveTimeSlot = (index) => {
    const newHours = currentDayData.hours.filter((_, i) => i !== index)
    onChange({
      ...currentDayData,
      hours: newHours,
    })
  }

  const handleTimeSlotChange = (index, timeSlot) => {
    const newHours = [...currentDayData.hours]
    newHours[index] = timeSlot
    onChange({
      ...currentDayData,
      hours: newHours,
    })
  }

  return (
    <div className="p-4 hover:bg-gray-50 dark:hover:bg-gray-700/30 transition-colors">
      <div className="flex items-start gap-4">
        {/* 曜日名とトグル */}
        <div className="w-32 flex-shrink-0">
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={currentDayData.isOpen}
              onChange={handleToggleOpen}
              className="w-4 h-4 text-purple-600 rounded focus:ring-2 focus:ring-purple-500"
            />
            <span className="text-sm font-medium text-gray-900 dark:text-white">
              {dayLabel}
            </span>
          </div>
        </div>

        {/* 時間帯設定 */}
        <div className="flex-1">
          {!currentDayData.isOpen ? (
            <div className="py-1">
              <span className="text-sm text-gray-500 dark:text-gray-400">休業日</span>
            </div>
          ) : (
            <div className="space-y-2">
              {currentDayData.hours.map((timeSlot, index) => (
                <TimeSlotEditor
                  key={index}
                  timeSlot={timeSlot}
                  onChange={(slot) => handleTimeSlotChange(index, slot)}
                  onRemove={() => handleRemoveTimeSlot(index)}
                  canRemove={currentDayData.hours.length > 1}
                />
              ))}
              <button
                onClick={handleAddTimeSlot}
                className="flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-purple-700 dark:text-purple-300 bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded-lg hover:bg-purple-100 dark:hover:bg-purple-900/30 transition-colors"
              >
                <Plus className="w-3 h-3" />
                時間帯を追加
              </button>
            </div>
          )}
        </div>

        {/* コピーボタン */}
        <div className="flex-shrink-0">
          <button
            onClick={onCopyToAll}
            className="p-2 text-gray-500 dark:text-gray-400 hover:text-purple-600 dark:hover:text-purple-400 hover:bg-purple-50 dark:hover:bg-purple-900/20 rounded-lg transition-colors"
            title="全曜日にコピー"
          >
            <Copy className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  )
}
